
































import { Input, Button } from 'element-ui'
import appealSetup from '../logic'
import props from '../props'
export default {
  name: 'mobileIllegalAppeal',
  props,
  components: {
    ElInput: Input,
    ElButton: Button
  },
  setup: appealSetup
} as any
